import React from 'react';
import { motion } from 'framer-motion';
import {
    salesforceModules,
    liveProjectsLearnersSF,
    liveProjectsBusinessesSF,
    businessBenefitsSF,
    recentProjectsSF,
    trainingOfferingsSF,
    trainingModulesSF,
    whyChooseUsSF
} from '../../data/expertiseData'; // Import Salesforce data

// Placeholder Icons - Use actual icons later
const SalesforceIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 640 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"></path>
    </svg>
);
const CheckCircleIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
);
const BriefcaseIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"></path></svg>
);
const UserGroupIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"></path></svg>
);
const CheckIconBig = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
);
const CheckIconGreen = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="18" width="18" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
);
const OfficeBuildingIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"></path></svg>
);

function SalesforceExpertise() {

    const sectionVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const gridContainerVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
    };

    const gridItemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
    };

  return (
    <section id="salesforce-services" className="py-20 bg-gradient-to-b from-sky-50 via-gray-50 to-gray-50 overflow-hidden border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
            className="text-center mb-16"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
        >
          <span className="text-[#00A1E0] font-semibold tracking-wider uppercase">Our Salesforce Expertise</span>
          <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">Comprehensive Salesforce Solutions</h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Leveraging the power of the Salesforce platform to transform your sales, service, and marketing operations.
          </p>
        </motion.div>

        {/* Salesforce Module Grid */}
        <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20"
            variants={gridContainerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
        >
          {salesforceModules.map((module, index) => (
            <motion.div
                key={index}
                className="bg-white rounded-xl shadow-lg hover:shadow-[#00a1e0]/20 transition-shadow p-6 h-full"
                variants={gridItemVariants}
             >
              <div className="flex items-center mb-4">
                <div className="mr-3 bg-sky-100 p-3 rounded-lg text-[#00A1E0]">
                  <SalesforceIcon />
                </div>
                <h3 className="text-xl font-bold text-gray-800">{module.title}</h3>
              </div>
              <ul className="space-y-2 mt-4">
                {module.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <span className="text-[#00A1E0] mt-1 mr-2 flex-shrink-0"><CheckCircleIcon /></span>
                    <span className="text-gray-700 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>

        {/* Live Projects & Training Section Wrapper */}
        <motion.div
            className="mb-16"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
            transition={{ delay: 0.2 }}
            >
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Live Salesforce Projects for Training & Business Solutions</h2>
            <p className="text-gray-700 max-w-4xl mx-auto">
              Gain practical Salesforce skills or implement robust CRM solutions with our real-world project approach.
            </p>
          </div>

          <motion.div
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12"
            variants={gridContainerVariants}
           >
            {/* Card for Learners */}
            <motion.div className="bg-white rounded-xl overflow-hidden shadow-lg" variants={gridItemVariants}>
              <div className="bg-gradient-to-r from-[#00A1E0] to-blue-600 px-6 py-4 flex items-center">
                <div className="bg-white/20 p-3 rounded-lg text-white mr-4"><UserGroupIcon /></div>
                <h3 className="text-xl font-bold text-white">For Salesforce Learners: Hands-on Live Projects</h3>
              </div>
              <div className="p-6">
                <p className="text-gray-700 mb-4 text-sm">
                    Our Salesforce training projects immerse learners in practical scenarios, covering implementation, customization, and integration tasks essential for career growth.
                </p>
                <div className="mb-4">
                  <h4 className="text-md font-semibold mb-2 text-gray-800">🔹 Who Can Join?</h4>
                  <p className="text-gray-700 text-sm">
                    Aspiring Salesforce Admins, Developers, Consultants, and professionals seeking practical platform expertise.
                  </p>
                </div>
                <h4 className="text-md font-semibold mb-2 text-gray-800">Examples of Live Projects:</h4>
                <ul className="space-y-2 mb-6">
                  {liveProjectsLearnersSF.map((project, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-green-500 mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                      <span className="text-gray-700 text-sm">{project}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>

            {/* Card for Businesses */}
            <motion.div className="bg-white rounded-xl overflow-hidden shadow-lg" variants={gridItemVariants}>
              <div className="bg-gradient-to-r from-[#00A1E0] to-blue-600 px-6 py-4 flex items-center">
                <div className="bg-white/20 p-3 rounded-lg text-white mr-4"><BriefcaseIcon /></div>
                <h3 className="text-xl font-bold text-white">For Businesses: Real-Time Salesforce Implementation</h3>
              </div>
               <div className="p-6">
                 <p className="text-gray-700 mb-4 text-sm">
                     We deliver tailored Salesforce solutions addressing critical business needs, from initial setup to complex integrations and custom development.
                 </p>
                 <h4 className="text-md font-semibold mb-2 text-gray-800">Examples of Live Projects:</h4>
                  <ul className="space-y-2 mb-6">
                   {liveProjectsBusinessesSF.map((project, idx) => (
                     <li key={idx} className="flex items-start">
                       <span className="text-green-500 mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                       <span className="text-gray-700 text-sm">{project}</span>
                     </li>
                   ))}
                 </ul>
                 <div>
                   <h4 className="text-md font-semibold mb-2 text-gray-800">📌 How It Benefits Businesses?</h4>
                    <ul className="space-y-2">
                       {businessBenefitsSF.map((benefit, idx) => (
                         <li key={idx} className="flex items-start">
                           <span className="text-green-500 mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                           <span className="text-gray-700 text-sm">{benefit}</span>
                         </li>
                       ))}
                     </ul>
                 </div>
               </div>
            </motion.div>
          </motion.div>

          {/* Recent Projects Section */}
            <motion.div
                className="bg-white rounded-xl p-6 shadow-lg mt-6"
                variants={gridItemVariants}
             >
                <h3 className="text-xl font-bold text-gray-800 mb-4">Recent Live Salesforce Projects:</h3>
                {recentProjectsSF.map((project, idx) => (
                    <div key={idx} className="flex items-start mb-4 last:mb-0">
                        <span className="text-green-500 mt-1 mr-3 flex-shrink-0"><CheckIconGreen /></span>
                        <div>
                            <h4 className="font-semibold text-gray-800">{project.title}</h4>
                            <p className="text-gray-600 text-sm">{project.description}</p>
                        </div>
                    </div>
                ))}
            </motion.div>
        </motion.div>

         {/* Training Section */}
        <motion.div
            className="mb-16"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
            transition={{ delay: 0.3 }}
        >
            <div className="bg-white rounded-xl overflow-hidden shadow-xl">
                <div className="bg-gradient-to-r from-[#00A1E0] to-blue-600 px-6 py-4">
                    <div className="flex items-center">
                        <div className="bg-white/20 p-3 rounded-lg text-white mr-4"><UserGroupIcon /></div>
                        <h3 className="text-2xl font-bold text-white">Salesforce Training Programs</h3>
                    </div>
                </div>
                <div className="p-8">
                    <p className="text-gray-700 mb-6 text-sm">Empower your teams with comprehensive Salesforce training, covering administration, development, and key cloud functionalities.</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        <div>
                            <h4 className="text-lg font-semibold mb-3 text-gray-800">Training Offerings:</h4>
                            <ul className="space-y-2">
                                {trainingOfferingsSF.map((offering, idx) => (
                                    <li key={idx} className="flex items-start">
                                        <span className="text-[#00A1E0] mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                                        <span className="text-gray-700 text-sm">{offering}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-lg font-semibold mb-3 text-gray-800">Training Modules We Offer:</h4>
                            <ul className="space-y-2">
                                {trainingModulesSF.map((mod, idx) => (
                                    <li key={idx} className="flex items-start">
                                        <span className="text-[#00A1E0] mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                                        <span className="text-gray-700 text-sm">{mod}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <p className="text-gray-700 italic text-sm">Our training focuses on practical application and certification readiness.</p>
                </div>
            </div>
        </motion.div>

        {/* Why Choose Us Section */}
        <motion.div
            className="bg-white rounded-xl p-8 shadow-lg"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={sectionVariants}
            transition={{ delay: 0.1 }}
        >
          <div className="flex items-center mb-6">
            <div className="bg-sky-100 p-3 rounded-lg text-[#00A1E0] mr-4"><OfficeBuildingIcon /></div>
            <h3 className="text-2xl font-bold text-gray-800">Why Choose Us for Salesforce?</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {whyChooseUsSF.map((reason, idx) => (
                <div key={idx} className="flex items-start">
                    <span className="text-green-500 mt-1 mr-3 flex-shrink-0"><CheckIconGreen /></span>
                    <span className="text-gray-700 text-sm">{reason}</span>
                </div>
            ))}
          </div>
          <p className="mt-6 text-gray-700 text-sm">We are dedicated to maximizing your Salesforce investment through expert implementation and tailored training.</p>
        </motion.div>

        {/* Call to Action */}
        <motion.div
            className="mt-16 text-center"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
            transition={{ delay: 0.2 }}
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Elevate Your CRM with Salesforce?</h3>
          <p className="text-lg text-gray-700 mb-8">Contact us to discuss your Salesforce project or training requirements.</p>
          <a href="#contact" className="bg-[#00A1E0] text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-600 transition-colors inline-flex items-center">
            Get Salesforce Quote
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default SalesforceExpertise; 